<template>
  <div class="promotion">
    <div class="app_header">
      <nuxt-link :to="`/company/${company.companyId}`" :target="$_newtab">
        <div class="app_header_logo">
          <img :src="company.logoOssUrl || defaultCompanyLogo" />
        </div>
      </nuxt-link>
      <nuxt-link :to="`/company/${company.companyId}`" :target="$_newtab">
        <h2 class="app_header_project_short_name">{{ company.shortName }}</h2>
      </nuxt-link>
    </div>
    <BlankPage v-if="!isShow" />
    <div v-else>
      <div class="promotion-container">
        <div class="promotion_sticky promotion_background_white">
          <PromotinHeader
            :img-front="frontfaceImg"
            :amount="promotionAmount"
            :title="title"
            @onClickPromotionHeader="openDialogQuotation"
          />
        </div>
        <div class="promotion-content">
          <div class="promotion-left promotion_background_white">
            <div class="hide_on_pc img_wap">
              <img :src="frontfaceImg" class="promotion-content-front-image" />
            </div>
            <div
              class="hide_on_pc promotion-right_title promotion_background_white"
            >
              <h1 class="pc_owner_mod_header border_bottom">{{ title }}</h1>
            </div>

            <div v-html="contentHtml" class="promotion-rich-text" />
          </div>
          <div class="promotion-right">
            <PromotionActivity :textarea="description" />
            <PromotionConnection
              :title="companyName"
              :evaluate-avg="evaluateAvg"
              @onClickPromotionConnection="openDialogConnection"
            />
            <div class="promotion_footer_mobile hide_on_pc">
              <a :href="techSupport.link">
                {{ techSupport.description }}
              </a>
            </div>
            <div class="promotion_patch hide_on_pc" style="height:76px;"></div>
          </div>
        </div>
        <PromotionMobileFooter
          :title="companyName"
          :evaluate-avg="evaluateAvg"
          :logo="logo"
          @onClickPromotionFooter="openDialogQuotation"
        />
      </div>

      <div class="promotion_footer hide_on_mobile">
        <a :href="techSupport.link">
          {{ techSupport.description }}
        </a>
      </div>
      <QuotationDialog
        :visible.sync="quotationDialogVisbile"
        :title="companyName + dialogTitleHeader"
        :content="dialogContentHeader"
        :tag="dialogMobileHeader"
        :button-text="dialogBtnHeader"
        @click-submit="onClickSubmitHeader"
      />

      <QuotationDialog
        :visible.sync="connectDialogVisbile"
        :title="companyName + dialogTitleConnection"
        :content="dialogContentConnection"
        :tag="dialogMobileConnection"
        :button-text="dialogBtnConnection"
        @click-submit="onClickSubmitConnection"
      />
    </div>
  </div>
</template>

<script>
import BlankPage from '../components/BlankPage'

import PromotinHeader from '../components/Promotion/PromotionHeader'
// import PromotionContent from '../components/Promotion/PromotionContent'
import PromotionConnection from '../components/Promotion/PromotionConnection'
import PromotionMobileFooter from '../components/Promotion/PromotionMobileFooter'
import PromotionActivity from '../components/Promotion/PromotionActivity'
import { getClassicalDetail } from '~/api/classical.api'
import { saveCustomerOrderManager, saveBrowsingHistory } from '~/api/common.api'
import yqzConstant from '~/constant/target-type.constant'
const xss = require('xss')

export default {
  head() {
    const url = process.env.ONLINE_URL + this.$route.path
    const title = `${this.title}-${this.companyName}优惠促销`
    const desc = this.description
      ? this.description.slice(0, 99).replace('\n', ' ')
      : `${this.companyName}促销活动，为您提供最优惠的装修好礼，限时推出，名额有限，邀您免费一键报名。想要最优惠、最靠谱的装修，就来${this.companyName}！`
    const location = `province=${this.companyProvince};city=${this.companyCity}`

    return {
      title,
      meta: [
        {
          name: 'keywords',
          content: `${this.companyName}促销活动,${this.companyName}优惠详情`
        },
        {
          name: 'description',
          content: desc
        },
        {
          name: 'og:url',
          content: url
        },
        {
          name: 'og:title',
          content: title
        },
        {
          name: 'og:description',
          content: desc
        },
        {
          name: 'location',
          content: location
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: url
        }
      ]
    }
  },
  components: {
    BlankPage,
    PromotinHeader,
    // PromotionContent,
    PromotionConnection,
    PromotionMobileFooter,
    PromotionActivity
  },
  data() {
    return {
      quotationDialogVisbile: false,
      connectDialogVisbile: false,
      dialogTitleHeader: '邀你报名活动',
      dialogContentHeader:
        '钜惠来袭，不容错过。稍后客服会电话联系你，沟通具体的服务流程',
      dialogBtnHeader: '立即抢名额',
      dialogMobileHeader: '报名有礼',

      dialogTitleConnection: '为你服务',
      dialogContentConnection:
        '对优惠活动、装修事宜有任何问题，欢迎免费咨询。稍后客服会电话联系你，沟通具体的服务流程',
      dialogBtnConnection: '我要咨询',
      dialogMobileConnection: '免费咨询'
    }
  },
  async asyncData(context) {
    const {
      company,
      province: companyProvince,
      city: companyCity,
      techSupport
    } = context.store.state.company
    const companyId = company.companyId
    const classicalProjectId = context.route.params.promotionId
    const resDetail = await getClassicalDetail({ classicalProjectId })
    const faceImg = [
      {
        imgOssUrl: resDetail.faceImgOssUrl
      }
    ]
    const frontfaceImg = resDetail.faceImgOssUrl
    const bodyImg = resDetail.photoList
      ? resDetail.photoList.map((item) => {
          return { imgOssUrl: item.pictureOssUrl }
        })
      : []
    const isShow = !!resDetail.classicalProjectId
    const imageList = faceImg.concat(bodyImg)
    const promotionAmount = resDetail.pageViewCount
    const description = resDetail.description
    const title = resDetail.title
    const companyName = company.shortName
    const evaluateAvg = company.evaluateAvg
    // const contentHtml = xss(resDetail.contentHtml)

    // xss 防御
    const options = {
      whiteList: {
        a: ['target', 'href', 'title', 'style'],
        abbr: ['title'],
        address: [],
        area: ['shape', 'coords', 'href', 'alt'],
        article: [],
        aside: [],
        audio: [
          'autoplay',
          'controls',
          'crossorigin',
          'loop',
          'muted',
          'preload',
          'src'
        ],
        b: ['style', 'class'],
        bdi: ['dir'],
        bdo: ['dir'],
        big: [],
        blockquote: ['cite'],
        br: ['style'],
        caption: [],
        center: [],
        cite: [],
        code: [],
        col: ['align', 'valign', 'span', 'width'],
        colgroup: ['align', 'valign', 'span', 'width'],
        dd: [],
        del: ['datetime'],
        details: ['open'],
        div: [],
        dl: [],
        dt: [],
        em: [],
        figcaption: [],
        figure: [],
        font: ['color', 'size', 'face', 'style'],
        footer: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        header: [],
        hr: ['class', 'style'],
        i: ['style'],
        img: [
          'src',
          'alt',
          'title',
          'width',
          'height',
          'style',
          'class',
          'data-href'
        ],
        ins: ['datetime'],
        li: ['class'],
        mark: [],
        nav: [],
        ol: ['class'],
        p: ['class', 'style'],
        pre: [],
        s: [],
        section: [],
        small: [],
        span: ['class', 'style'],
        sub: [],
        summary: [],
        sup: [],
        strong: [],
        strike: ['style', 'class'],
        table: ['width', 'border', 'align', 'valign'],
        tbody: ['align', 'valign'],
        td: ['width', 'rowspan', 'colspan', 'align', 'valign'],
        tfoot: ['align', 'valign'],
        th: ['width', 'rowspan', 'colspan', 'align', 'valign'],
        thead: ['align', 'valign'],
        tr: ['rowspan', 'align', 'valign'],
        tt: [],
        u: [],
        ul: ['class', 'style'],
        video: [
          'autoplay',
          'controls',
          'crossorigin',
          'loop',
          'muted',
          'playsinline',
          'poster',
          'preload',
          'src',
          'height',
          'width'
        ]
      }
    }
    const myxss = new xss.FilterXSS(options)
    let contentHtml = myxss.process(resDetail.contentHtml)
    contentHtml = contentHtml.replace(
      /<img(.*?)data-href="(.*?)"(.*?)>/gi,
      `<div class="yqz_link_img"><img src="https://oss.1qizhuang.com/image/editor/data-href.png" class="yqz_link_img_icon" /><a href="$2" target="_blank"><img$1 $3></a></div>`
    )
    const logo = company.logoOssUrl
      ? company.logoOssUrl
      : 'https://oss.1qizhuang.com/image/app/default-company.png'

    return {
      frontfaceImg,
      contentHtml,
      classicalProjectId,
      title,
      description,
      imageList,
      evaluateAvg,
      promotionAmount,
      companyName,
      logo,
      resDetail,
      company,
      companyId,
      companyCity,
      companyProvince,
      techSupport,
      isShow
    }
  },
  beforeMount() {
    saveBrowsingHistory({
      targetId: this.classicalProjectId,
      companyId: this.companyId,
      targetType: yqzConstant.PROMOTION
    })
  },
  methods: {
    async onClickSubmitHeader(mobile) {
      const res = await saveCustomerOrderManager({
        mobile,
        targetType: yqzConstant.PROMOTION,
        target: this.classicalProjectId,
        entryPoint: '',
        serviceName: '促销活动',
        landingPageId: 13,
        companyId: this.companyId
      })

      if (res.judge) {
        this.$notify({
          message: res.msg,
          type: 'success',
          duration: 3000
        })
      } else {
        this.$notify({
          message: res.msg,
          type: 'warning',
          duration: 3000
        })
      }

      this.quotationDialogVisbile = false
    },
    async onClickSubmitConnection(mobile) {
      const res = await saveCustomerOrderManager({
        mobile,
        targetType: yqzConstant.PROMOTION,
        target: this.classicalProjectId,
        entryPoint: '',
        serviceName: '促销活动',
        landingPageId: 13,
        companyId: this.companyId
      })

      if (res.judge) {
        this.$notify({
          message: res.msg,
          type: 'success',
          duration: 3000
        })
      } else {
        this.$notify({
          message: res.msg,
          type: 'warning',
          duration: 3000
        })
      }

      this.connectDialogVisbile = false
    },
    openDialogQuotation() {
      this.quotationDialogVisbile = true
    },
    openDialogConnection() {
      this.connectDialogVisbile = true
    }
  }
}
</script>

<style lang="scss">
b {
  font-weight: bold;
}
i {
  font-style: italic;
}
h1,
h2,
h3,
h4,
h5 {
  font-weight: bold;
}
.promotion-rich-text {
  .yqz_link_img {
    position: relative;
  }
  .yqz_link_img_icon {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 28px;
    height: 38px;
  }
  p {
    padding: 10px 0px;
    color: #444444;
    font-size: 15px;
  }
  img {
    padding: 5px 0px;
  }
  hr {
    border-top: 0px solid #e0e6ed;
    margin: 15px 0px;
  }
}

// .promotion-front-image-container {
//   position: relative;
//   width: 100%;
//   padding-top: 56.25%;
// }
.promotion-front-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.promotion_sticky {
  position: sticky;
  top: 0;
  z-index: 1888;
}
.promotion_background_white {
  background: white;
  .pc_owner_mod_header {
    line-height: 30px;
  }
}
.promotion {
  .app_header {
    .app_header_logo {
      width: 36px;
      height: 36px;
      > img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .app_header_project_short_name {
      font-size: 20px;
      font-weight: 500;
      color: rgba(42, 42, 42, 1);
      line-height: 20px;
      padding-left: 10px;
    }
  }
  background: white;
  .promotion-container {
    background: white;
    margin: 0 auto;
    width: 940px;
    .promotion_footer_mobile {
      margin-top: 20px;
      width: 100%;
      height: 52px;
      background: rgba(247, 247, 247, 1);
      text-align: center;
      position: relative;
      a {
        font-size: 12px;
        font-weight: 600;
        color: rgba(155, 155, 155, 1);
        line-height: 52px;
      }
    }
  }
  .promotion_header {
    margin-bottom: 20px;
    position: sticky;
    background: white;
    z-index: 1888;
    top: 0;
  }
  .promotion-content {
    display: flex;
    justify-content: space-between;
    width: 100%;
    .promotion-left {
      width: 675px;

      margin-right: 20px;
    }
    .promotion-right {
      flex-grow: 1;
      max-width: 256px;
      .promotion-right_title {
        padding: 15px 15px 0px 15px;
        font-size: 20px;
        font-weight: 500;
        color: rgba(68, 68, 68, 1);
        line-height: 20px;
      }
    }
  }
  .promotion_connection {
    margin-bottom: 20px;
  }
  .promotion_mobile_footer {
    display: none;
  }
}

//only pc
@media screen and (min-width: 940px) {
  .promotion {
    .promotion_footer {
      margin-top: 20px;
      width: 100%;
      height: 52px;
      background: rgba(247, 247, 247, 1);
      text-align: center;
      position: relative;
      bottom: 0;
      right: 0;
      a {
        font-size: 12px;
        font-weight: 600;
        color: rgba(155, 155, 155, 1);
        line-height: 52px;
      }
    }
  }
}

//only mobile
@media screen and (max-width: 940px) {
  .promotion {
    .promotion-container {
      background: #f7f7f7;
      position: absolute;
      top: 56px;
      bottom: 0px;
      width: 100%;
    }

    .promotion_header {
      display: none;
    }
    .promotion-content {
      flex-direction: column;
      .pc_owner_mod_header {
        padding: 20px 15px 0px;
      }
      .pc_owner_mod_header::after {
        border-bottom: 1px solid rgb(224, 230, 237);
        content: '';
        width: 100%;
        height: 20px;
        display: block;
        margin: 0 auto;
      }
      .img_wap {
        padding-bottom: 56%;
        width: 100%;
        position: relative;
        .promotion-content-front-image {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          object-fit: cover;
        }
      }

      .promotion-left {
        flex-grow: 1;
        width: 100%;
        .promotion-rich-text {
          padding: 15px;
        }
      }
      .promotion-right {
        flex-grow: 2;

        width: 100%;
        max-width: 100%;
      }
    }
    .promotion_connection {
      display: none;
    }
    .promotion_mobile_footer {
      display: block;
      position: fixed;
      bottom: 0;
      right: 0;
    }
    .project_footer {
      display: none;
    }
  }
}
</style>
